<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: l_hc
 * @LastEditTime: 2019-10-18 18:28:59
 * @Description: 普通仓库供给列表，状态：待发布、已发布、已成交。
 -->
<template>
  <div class="content-container">
    <div class="supply-head">
      <div class="slider-list">
        <div :class="{ 'selected': state == '1'}" class="item" @click="toggleState('1')">待发布</div>
        <div :class="{ 'selected': state == '2'}" class="item" @click="toggleState('2')">已发布</div>
        <!-- <div :class="{ 'selected': state == '3'}" class="item" @click="toggleState('3')">已成交</div> -->
      </div>
      <!-- 查询表单  -->
      <div class="supply-head-form">
        <div class="fileds">
          <el-form ref="form" :model="queryParams" :inline="true" :rules="rule">
            <div class="supply-condition">
              <el-form-item label="租单名称:" prop="supplyName">
                <el-input v-model.trim="queryParams.supplyName" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="储存品类:" prop="storageType">
                <el-select v-model="queryParams.storageType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in storageType.storageType"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="可租用面积:" prop="rentableStartArea">
                <div class="supply-area">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="rentableStartArea">
                        <el-input
                          v-model.number="queryParams.rentableStartArea"
                          placeholder="请输入"
                          @change="startChange"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="2">
                      <span>至</span>
                    </el-col>
                    <el-col :span="11">
                      <el-form-item prop="rentableStopArea">
                        <el-input
                          v-model.number="queryParams.rentableStopArea"
                          placeholder="请输入"
                          @change="endChange"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="库房位置:" prop="storageLocation">
                <el-cascader
                  v-model="queryParams.storageLocation"
                  :options="area"
                  :filterable="true"
                  :props="{ expandTrigger: 'hover' ,
                            checkStrictly: true}"
                  style="width: 100%;"
                  @expand-change="expandChange"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>

    <!--存入表格数据-->
    <article class="operations">
      <el-button
        v-if="state == '1'"
        size="small"
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="publishsupply('2')"
      >
        <i class="el-icon-plus" />发布
      </el-button>
      <!-- <el-button
        v-if="state == '2'"
        size="small"
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="publishsupply('1')"
      >
        <i class="el-icon-plus" />取消发布
      </el-button>-->
      <el-button
        v-if="state == '1'"
        size="small "
        class="form-item-btn"
        type="primary"
        style="background-color: #BE2316;border-color: #F56C6C;"
        @click="batchDel"
      >
        <i class="el-icon-delete-solid" />批量删除
      </el-button>
    </article>

    <div
      :class="{'orderSupply-data' :state == '3','tankSupply-data' :state == '2','supply-data' :state == '1'}"
    >
      <div class="supply-data-header">
        <ul>
          <li v-if="state == '1'">
            <el-checkbox v-model="allSelection" type="checkbox" @change="selection()" />
          </li>
          <li>租单名称</li>
          <li>储存品类</li>
          <li>库房位置</li>
          <li>可租用面积</li>
          <li>期望租金</li>
          <li v-if="state == '2'">预约企业</li>
          <li v-if="state == '2'">邀请企业</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" v-loading="viewManager.loading" class="supply-data-body">
        <template v-if="!viewManager.loading && data.length < 1">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(supply, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li v-if="state == '1'">
                <el-checkbox v-model="supply.selection" type="checkbox" @change="change()" />
              </li>
              <el-tooltip class="item" effect="dark" :content="supply.supplyName" placement="top">
                <li>{{ supply.supplyName }}</li>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="supply.storageTypeLabel"
                placement="top"
              >
                <li>{{ supply.storageTypeLabel }}</li>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="supply.storageLocationLabel"
                placement="top"
              >
                <li>{{ supply.storageLocationLabel }}</li>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="`${supply.rentableArea}m²`"
                placement="top"
              >
                <li>{{ supply.rentableArea }}m²</li>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="`${supply.expectPrice}元/m²/天`"
                placement="top"
              >
                <li>{{ supply.expectPrice }}元/m²/天</li>
              </el-tooltip>
              <el-tooltip
                v-if="state == '2' "
                class="item"
                effect="dark"
                :content="JSON.stringify(supply.orderUser.length)"
                placement="top"
              >
                <li>
                  <el-button type="text" @click="orderClick(supply)">{{ supply.orderUser.length }}</el-button>
                </li>
              </el-tooltip>
              <el-tooltip
                v-if="state == '2' "
                class="item"
                effect="dark"
                :content="JSON.stringify(supply.inviteUser.length)"
                placement="top"
              >
                <li>
                  <el-button type="text" @click="inviteClick(supply)">{{ supply.inviteUser.length }}</el-button>
                </li>
              </el-tooltip>
              <li>
                <el-button v-if="state == '2'" type="text" @click="popRecommendList(supply)">需求推荐</el-button>
                <el-divider v-if="state == '2'" direction="vertical" />
                <el-button
                  v-if="state == '2' && supply.orderUser.length < 1 && supply.inviteUser.length < 1"
                  type="text"
                  @click="publishGetSupply('1',supply)"
                >取消发布</el-button>
                <!-- <el-divider v-if="state == '2'" direction="vertical" /> -->
                <el-button v-if="state == '1'" type="text" @click="edit(supply)">编辑</el-button>
                <el-divider v-if="state == '1'" direction="vertical" />
                <el-button
                  v-if="state == '1'"
                  type="text"
                  @click="publishGetSupply('2',supply)"
                >立即发布</el-button>
                <!-- <el-divider v-if="state == '1'" direction="vertical" /> -->
                <el-button
                  v-if="state == '1'"
                  type="text"
                  style="color: #be2316 !important;"
                  @click="del(supply.id)"
                >删除</el-button>
                <el-divider v-if="state == '1'" direction="vertical" />
                <el-button
                  plain
                  size="small"
                  style="color: #be2316 !important;"
                  @click="supplyInfo(supply)"
                >
                  详情
                  <i :class="{'expand': !supply.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <storeSupplyInfo v-if="!supply.hidden" :supply="supply" />
          </div>
        </template>
      </div>
      <div class="supply-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>

    <el-dialog
      :visible.sync="invitationManager.visible"
      title="编辑"
      width="80%"
      @click="invitationManager.close"
    >
      <el-form
        ref="storageSupply"
        :rules="storageSupplyRules"
        :model="storageSupply"
        :label-position="'right'"
        label-width="120px"
        style="padding-left: 0rem;padding-right: 2rem;"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="租单名称" prop="supplyName">
              <el-input v-model="storageSupply.supplyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="仓库类型" prop="warehouseType">
              <el-select v-model="storageSupply.warehouseType" warehouse-type="请选择">
                <el-option
                  v-for="city in storageType.warehouseType"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起租日期" prop="leaseTime">
              <el-date-picker
                v-model="storageSupply.leaseTime"
                :editable="false"
                type="date"
                :picker-options="pickerOptions"
                placeholder="选择日期"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="储存品类" prop="storageType">
              <el-checkbox
                v-model="checkAll"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
              >不限</el-checkbox>
              <el-checkbox-group
                v-model="storageSupply.storageType"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="city in storageType.storageType"
                  :key="city.label"
                  :label="city.value"
                >{{ city.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="建筑面积" prop="coveredArea">
              <el-input v-model="storageSupply.coveredArea">
                <template slot="append">㎡</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起租年限" prop="leaseTerm">
              <el-select
                v-model="storageSupply.leaseTerm"
                style="width:100%;"
                placeholder="请选择起租年限"
              >
                <el-option
                  v-for="city in storageType.leaseTerm"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="消防资质" prop="fireQualification">
              <el-select v-model="storageSupply.fireQualification" placeholder="请选择消防资质">
                <el-option
                  v-for="city in storageType.fireQualification"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="租金" prop="expectPrice">
              <el-input v-model="storageSupply.expectPrice">
                <template slot="append">元/㎡/天</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="库房位置" prop="storageLocation">
              <el-cascader
                v-model="storageSupply.storageLocation"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover' ,
                          checkStrictly: true}"
                style="width: 100%;"
                class="storageLocation"
                @expand-change="expandChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细位置" class="detailedLocation" prop="detailedLocation">
              <el-autocomplete
                v-model="storageSupply.detailedLocation"
                popper-class="my-autocomplete"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                style="width: 100%;"
                @select="handleSelect"
              >
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                  <!--<span class="addr">{{ item.address }}</span>-->
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="可租用面积" prop="rentableArea">
              <el-input v-model="storageSupply.rentableArea">
                <template slot="append">㎡</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起租面积" prop="lettableArea">
              <el-input v-model="storageSupply.lettableArea">
                <template slot="append">㎡</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="库内设备" prop="warehouseEquipment">
              <el-select v-model="storageSupply.warehouseEquipment" multiple placeholder="请选择">
                <el-option
                  v-for="city in storageType.storeEquipment"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地坪质地" prop="floorTexture">
              <el-select v-model="storageSupply.floorTexture" placeholder="请选择地坪质地">
                <el-option
                  v-for="city in storageType.floorTexture"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="地坪承重" prop="floorWeight">
              <el-input v-model="storageSupply.floorWeight">
                <template slot="append">吨/㎡</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卸货平台" prop="landingPlatform">
              <el-select v-model="storageSupply.landingPlatform" placeholder="请选择卸货平台">
                <el-option
                  v-for="city in storageType.landingPlatform"
                  :key="city.label"
                  :label="city.label"
                  :value="city.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="库房照片" prop="storageUrl">
              <g-upload
                :max-size="1"
                :limit="6"
                is-edit
                :method-name="supplyFile"
                :multiple="true"
                :img-list.sync="storageSupply.storageUrl"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="storageSupply.companyName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="联系人" prop="linkMan">
              <el-input v-model="storageSupply.linkMan" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="telephone">
              <el-input v-model="storageSupply.telephone" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="仓库简介" prop="storageRecommend">
              <el-input v-model="storageSupply.storageRecommend" type="textarea" :rows="6" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label>
              <span style="color: #be2316;">注：</span>
              <span>*均为必填项</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button type="danger" plain size="small" @click="storageSupplyEdit('storageSupply')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <demandSuggest
      warehousing-type="1"
      :invitation-form="demandSuggestData"
      :invitation-manager="recommendManager.visible"
      @close="recommendManager.close"
    />
    <warehouseCompany
      warehousing-type="1"
      :ware-ord-inv-type="companyManager.type"
      :title-name="companyManager.title"
      warehouse-type="supply"
      :company-form="companyManager.data"
      :company-manager="companyManager.visible"
      @close="companyManager.close"
    />
  </div>
</template>

<script>
import AMap from 'AMap' // 引入高德地图
import storeSupplyInfo from './components/storeSupplyInfo'
import demandSuggest from '../components/demandSuggest'
import warehouseCompany from '../components/warehouseCompany'
import {
  findPageSupply,
  getArea,
  supplyRemove,
  delBatch,
  supplyEdit,
  getDict,
  issueBatch
} from '@/api/personal/store/store-supply-list/storeSupply'
import { tableClass } from '@/api/personal/store/store-supply-list/StoreSupplyParam'

import { DatabaseUtil } from '@/utils/databaseUtils'

import { isValidArray } from '@/utils/utilsMethods'

import { storageSupplyRules } from '../dataConfig/rules'

const dataBase = new DatabaseUtil()
const table = tableClass.getTable() // 引用表格参数类
console.log(table)
const requiredItems = () => {
  const keys = []
  for (const key in storageSupplyRules) {
    if (storageSupplyRules[key].some(item => item.required)) {
      keys.push(key)
    }
  }
  return keys
}

const validateData = item => {
  for (const key in item) {
    if (requiredItems().some(i => i === key)) {
      if (!item[key]) {
        return { state: false, key: key }
      } else if (typeof item[key] === 'string' && item[key] === '') {
        return { state: false, key: key }
      } else if (
        Object.prototype.toString.call(item[key]) === 'Array' &&
        item[key].length == 0
      ) {
        return { state: false, key: key }
      }
    }
  }
}

export default {
  name: 'StoreSupplyList',
  components: {
    storeSupplyInfo,
    demandSuggest,
    warehouseCompany
  },
  data: function() {
    // 待发布/已发布可租用面积校验方法
    var validateRentableArea = (rule, value, callback) => {
      if (parseFloat(this.queryParams.rentableStartArea) >
          parseFloat(this.queryParams.rentableStopArea)) {
        callback(new Error('请输入最大值'))
      } else {
        callback()
      }
    }
    // 可租用面积校验方法
    var rentableArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入可租用面积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.storageSupply.coveredArea) {
            return callback(new Error('请先输入建筑面积'))
          } else {
            if (
              parseFloat(this.storageSupply.coveredArea) < parseFloat(value)
            ) {
              return callback(
                new Error('可租用面积超出范围(不得超出建筑面积)')
              )
            } else {
              if (value != 0 && number.reg.test(value)) {
                callback()
              } else {
                callback(new Error(number.title))
              }
            }
          }
        }
      }
    }
    // 起租面积校验方法
    var lettableArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数、包括小数)'
      }
      if (!value) {
        return callback(new Error('请输入起租面积'))
      } else {
        if (number.reg.test(value) === false) {
          callback(new Error(number.title))
        } else {
          if (!this.storageSupply.rentableArea) {
            return callback(new Error('请先输入可租用面积'))
          } else {
            if (
              parseFloat(this.storageSupply.rentableArea) < parseFloat(value)
            ) {
              return callback(
                new Error('起租面积超出范围(不得超出可租用面积)')
              )
            } else {
              if (value != 0 && number.reg.test(value)) {
                callback()
              } else {
                callback(new Error(number.title))
              }
            }
          }
        }
      }
    }
    // 租金校验方法
    var expectPrice = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入租金'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }

    // 地坪承重校验方法
    var floorWeight = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入地坪承重'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    // 建筑面积校验方法
    var coveredArea = (rule, value, callback) => {
      const number = {
        reg: /^0{1}([.]\d{1,2})?$|^[1-9]\d{1,19}([.]{1}[0-9]{1,2})?$/,
        title: '请输入正确内容(正数不超过20位且小数点最多两位)'
      }
      if (!value) {
        return callback(new Error('请输入建筑面积'))
      } else {
        if (value != 0 && number.reg.test(value)) {
          callback()
        } else {
          callback(new Error(number.title))
        }
      }
    }
    return {
      // 可租用面积验证
      rule: {
        rentableStopArea: [
          { validator: validateRentableArea, trigger: 'blur' }]
      },
      invitationManager: {
        visible: false,
        close: () => {
          this.invitationManager.visible = false
        }
      },
      recommendManager: {
        visible: false,
        close: () => {
          this.loadData()
          this.recommendManager.visible = false
        }
      },
      companyManager: {
        visible: false,
        type: 'invite',
        title: '邀请企业信息',
        data: null,
        close: () => {
          this.companyManager.visible = false
        }
      },
      data: [],
      area: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      checkAll: false,
      isIndeterminate: true,
      allSelection: false,
      demandSuggestData: {},
      storageType: {
        storageType: [],
        leaseTerm: [],
        warehouseType: [],
        fireQualification: [],
        storeEquipment: [],
        floorTexture: [],
        landingPlatform: []
      },
      // 表格数据
      pagination: table.Page,
      queryParams: {
        supplyName: null,
        storageType: null,
        rentableStartArea: null,
        rentableStopArea: null,
        storageLocation: null,
        demandArea: null
      },
      state: '1',
      viewManager: {
        loading: true
      },
      supplyFile: 'cangchuFile',
      storageSupply: {
        longLat: '',
        supplyName: null, // 租单名称
        warehouseType: null, // 仓库类型
        storageType: [], // 储货类型
        leaseTime: null, // 起租日期
        lettableArea: null, // 起租面积
        rentableArea: null, // 可租用面积
        expectPrice: null, // 租金
        leaseTerm: null, // 起租年限
        storageLocation: null, // 库房位置
        detailedLocation: null, // 详细位置
        coveredArea: null, // 建筑面积
        fireQualification: null, // 消防资质
        warehouseEquipment: null, // 库内设备（多选）
        floorTexture: null, // 地坪质地
        floorWeight: null, // 地坪承重
        landingPlatform: null, // 卸货平台
        storageUrl: null, // 库房照片
        companyId: '212', // 公司id
        companyName: null, // 公司名称
        linkMan: null, // 联系人
        telephone: null, // 手机号
        storageRecommend: null, // 仓库简介
        remarks: null, // 备注
        publishStatus: null // 发布状态 1待发布 2已发布
      },
      storageSupplyRules: {
        supplyName: [
          {
            required: true,
            validator: this.$character(1, 50, 'check'),
            trigger: 'blur'
          }
        ], // 租单名称
        warehouseType: [
          { required: true, message: '请选择仓库类型', trigger: 'change' }
        ], // 仓库类型
        storageType: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个储货类型',
            trigger: 'change'
          }
        ], // 储货类型
        leaseTime: [
          { required: true, message: '请选择起租日期', trigger: 'change' }
        ], // 起租日期
        lettableArea: [{ required: true, validator: lettableArea }], // 起租面积
        rentableArea: [{ required: true, validator: rentableArea }], // 可租用面积
        expectPrice: [{ required: true, validator: expectPrice }], // 租金
        leaseTerm: [
          { required: true, message: '请选择起租年限', trigger: 'change' }
        ], // 起租年限
        storageLocation: [
          { required: true, message: '请选择库房位置', trigger: 'change' }
        ], // 库房位置
        detailedLocation: [
          { required: true, message: '请输入详细位置', trigger: 'blur' }
        ], // 详细位置
        coveredArea: [{ required: true, validator: coveredArea }], // 建筑面积
        fireQualification: [
          { required: true, message: '请选择消防资质', trigger: 'change' }
        ], // 消防资质
        warehouseEquipment: [
          { required: true, message: '请选择库内设备', trigger: 'blur' }
        ], // 库内设备（多选）
        floorTexture: [
          { required: true, message: '请选择地坪质地', trigger: 'change' }
        ], // 地坪质地
        floorWeight: [{ required: true, validator: floorWeight }], // 地坪承重
        landingPlatform: [
          { required: true, message: '请选择卸货平台', trigger: 'change' }
        ], // 卸货平台
        // storageUrl: [{ required: true, message: '请输入库房照片', trigger: 'blur' }], // 库房照片
        companyName: [
          {
            required: true,
            message: '未认证、请先认证个人信息',
            trigger: 'blur'
          }
        ], // 公司名称
        linkMan: [
          {
            required: true,
            validator: this.$character(1, 11, 'check'),
            trigger: 'blur'
          }
        ], // 联系人
        telephone: [{ required: true, validator: this.$validate('phone') }], // 手机号
        storageRecommend: [
          {
            required: true,
            validator: this.$character(1, 200, 'check'),
            trigger: 'blur'
          }
        ] // 仓库简介
      }
    }
  },
  computed: {
    getPublishState() {
      return this.state
    }
  },
  watch: {
    state: function() {
      this.loadData()
    },
    'queryParams.rentableStartArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.rentableStopArea)) {
          this.queryParams.rentableStopArea = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.rentableStartArea = ''
        } else {
          if (
            parseFloat(this.queryParams.rentableStartArea) >
          parseFloat(this.queryParams.rentableStopArea)
          ) {
            // this.queryParams.rentableStopArea = this.queryParams.rentableStartArea
          }
        }
      }
    },
    'queryParams.rentableStopArea': {
      handler: function(val) {
        var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
        if (!this.isEmpty(val) && this.isEmpty(this.queryParams.rentableStartArea)) {
          this.queryParams.rentableStartArea = ''
        }
        if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
          this.queryParams.rentableStopArea = ''
        }

        if (
          parseFloat(this.queryParams.rentableStartArea) >
          parseFloat(this.queryParams.rentableStopArea)
        ) {
          // this.queryParams.rentableStartArea = 1
        }
      }
    },
    'queryParams.supplyName': {
      handler: function(val) {
        var reg = this.$character(1, 20, 'regular')
        if (!reg.test(this.queryParams.supplyName)) {
          this.queryParams.supplyName = ''
        }
      }
    }
  },
  created: function() {
    (async() => {
      await this.getArea()
      await this.getLeaseTerm()
      await this.getStorageType()
      await this.getWarehouseType()
      await this.getFireQualification()
      await this.getStoreEquipment()
      await this.getFloorTexture()
      await this.getLandingPlatform()
      this.loadData()
    })()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    // 仓库面积范围
    startChange(val) {
      if (
        !this.isEmpty(this.queryParams.rentableStopArea) &&
        this.isEmpty(this.queryParams.rentableStartArea)
      ) {
        // this.queryParams.rentableStartArea = 1
      }
    },
    // 仓库面积范围
    endChange(val) {
      if (
        parseFloat(this.queryParams.rentableStartArea) >
        parseFloat(this.queryParams.rentableStopArea)
      ) {
        // console.log(`监控数据`)
        // this.queryParams.rentableStopArea = this.queryParams.rentableStartArea
      }
    },
    // 判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText =
              'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        // console.log('执行了')
      }, 100)
    },
    // 详情位置回调
    handleSelect(item) {
      const con = item.location.lat + ',' + item.location.lng
      this.storageSupply.longLat = con
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.storageSupply.storageLocation
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName('storageLocation')
        this.storageSupply.detailedLocation = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择库房位置!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择库房位置!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      // const map = this.map
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '邹平', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
          // panel: 'panel', // 结果列表将在此容器中进行展示。
          // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(queryString, (status, result) => {
          // alert(JSON.stringify(b))
          console.log(JSON.stringify(status))
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({
                title: element.name,
                value: element.address + element.name,
                address: element.name,
                location: element.location
              })
            })
            cb(results)
          } else {
            this.storageSupply.detailedLocation = ''
            cb(results)
            this.$message({
              message: '暂无数据!',
              offset: 100,
              type: 'warning'
            })
            // this.isErrorShow('暂无数据!')
            // cb(results)
          }
        })
      })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName(
          'detailedLocation'
        )
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector(
            '.el-form-item__content'
          )
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 储存类型多选
    handleCheckAllChange(val) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.value)
      })
      this.storageSupply.storageType = val ? cityOptionsList : []
      this.isIndeterminate = false
    },
    // 储存类型多选状态
    handleCheckedCitiesChange(value) {
      const cityOptionsList = []
      this.storageType.storageType.forEach(res => {
        cityOptionsList.push(res.value)
      })
      const checkedCount = value.length
      this.checkAll = checkedCount === cityOptionsList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < cityOptionsList.length
    },
    // 详情展示
    supplyInfo(supply) {
      if (supply.hidden) {
        this.data.map(res => {
          // console.log(res)
          res.hidden = true
          return res
        })
      }
      supply.hidden = !supply.hidden
    },
    // 起租年限类型字典
    getLeaseTerm() {
      this.getLocalStorageUtil('leaseTerm')
        .then(leaseTerm => {
          if (leaseTerm.length > 0) {
            leaseTerm.forEach(res => {
              this.storageType.leaseTerm.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('leaseTerm')
            .then(res => {
              const leaseTerm = JSON.parse(res.result)
              this.setLocalStorageUtil('leaseTerm', leaseTerm)
              if (leaseTerm.length > 0) {
                leaseTerm.forEach(res => {
                  this.storageType.leaseTerm.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area')
        .then(data => {
          this.area = data
        })
        .catch(() => {
          getArea()
            .then(data => {
              this.area = data.result
              this.setLocalStorageUtil('area', data.result)
            })
            .catch(error => {
              console.error(error)
            })
        })
    },
    // 储存类型字典
    getStorageType() {
      this.getLocalStorageUtil('storageType')
        .then(storageType => {
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('storageType')
            .then(res => {
              const storageType = JSON.parse(res.result)
              this.setLocalStorageUtil('storageType', storageType)
              if (storageType.length > 0) {
                storageType.forEach(res => {
                  this.storageType.storageType.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 仓库类型字典
    getWarehouseType() {
      this.getLocalStorageUtil('warehouseType')
        .then(warehouseType => {
          if (warehouseType.length > 0) {
            warehouseType.forEach(res => {
              this.storageType.warehouseType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('warehouseType')
            .then(res => {
              const warehouseType = JSON.parse(res.result)
              this.setLocalStorageUtil('warehouseType', warehouseType)
              if (warehouseType.length > 0) {
                warehouseType.forEach(res => {
                  this.storageType.warehouseType.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 消防资质字典
    getFireQualification() {
      this.getLocalStorageUtil('fireQualification')
        .then(fireQualification => {
          if (fireQualification.length > 0) {
            fireQualification.forEach(res => {
              this.storageType.fireQualification.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('fireQualification')
            .then(res => {
              const fireQualification = JSON.parse(res.result)
              this.setLocalStorageUtil('fireQualification', fireQualification)
              if (fireQualification.length > 0) {
                fireQualification.forEach(res => {
                  this.storageType.fireQualification.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 库内设备字典
    getStoreEquipment() {
      this.getLocalStorageUtil('storeEquipment')
        .then(storeEquipment => {
          if (storeEquipment.length > 0) {
            storeEquipment.forEach(res => {
              this.storageType.storeEquipment.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('storeEquipment')
            .then(res => {
              const storeEquipment = JSON.parse(res.result)
              this.setLocalStorageUtil('storeEquipment', storeEquipment)
              if (storeEquipment.length > 0) {
                storeEquipment.forEach(res => {
                  this.storageType.storeEquipment.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 地坪质地字典
    getFloorTexture() {
      this.getLocalStorageUtil('floorTexture')
        .then(floorTexture => {
          if (floorTexture.length > 0) {
            floorTexture.forEach(res => {
              this.storageType.floorTexture.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('floorTexture')
            .then(res => {
              const floorTexture = JSON.parse(res.result)
              this.setLocalStorageUtil('floorTexture', floorTexture)
              if (floorTexture.length > 0) {
                floorTexture.forEach(res => {
                  this.storageType.floorTexture.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 卸货平台字典
    getLandingPlatform() {
      this.getLocalStorageUtil('landingPlatform')
        .then(landingPlatform => {
          if (landingPlatform.length > 0) {
            landingPlatform.forEach(res => {
              this.storageType.landingPlatform.push({
                label: res.label,
                value: res.value
              })
            })
          }
        })
        .catch(() => {
          getDict('landingPlatform')
            .then(res => {
              const landingPlatform = JSON.parse(res.result)
              this.setLocalStorageUtil('landingPlatform', landingPlatform)
              if (landingPlatform.length > 0) {
                landingPlatform.forEach(res => {
                  this.storageType.landingPlatform.push({
                    label: res.label,
                    value: res.value
                  })
                })
              }
            })
            .catch(err => {
              console.error(err)
            })
        })
    },
    // 邀请企业信息
    inviteClick(res) {
      this.companyManager.type = 'invite'
      this.companyManager.title = '邀请企业信息'
      this.companyManager.data = res
      this.companyManager.visible = true
    },
    // 邀请企业信息
    orderClick(res) {
      this.companyManager.type = 'order'
      this.companyManager.title = '预约企业信息'
      this.companyManager.data = res
      this.companyManager.visible = true
    },
    // 列表切换监听
    toggleState(state) {
      this.state = state
      this.resetForm()
      this.loadData()
    },
    // 需求推荐
    popRecommendList(id) {
      // console.log(id)
      this.demandSuggestData = id
      // 根据id查询出对应列表
      this.recommendManager.visible = true
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
      this.queryParams.storageLocation = null
      this.loadData()
    },
    // 子项选择
    change() {
      this.allSelection = this.data.every(i => i.selection)
    },
    // 全选
    selection() {
      this.data.forEach(i => {
        if (i.selection !== this.allSelection) {
          i.selection = !i.selection
        }
      })
    },
    // 监听分页
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    // 监听分页
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 批量删除
    batchDel() {
      const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (ids.length > 0) {
        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBatch({ id: ids.join(',') })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: '删除成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: '请选择要删除的数据!'
        })
      }
    },
    // 初始化查询
    loadData() {
      console.log('回车事件')
      this.viewManager.loading = true
      this.queryParams.publishStatus = this.getPublishState
      // this.queryParams.userId = '0'
      this.queryParams.myType = true
      this.loadTableData()
      this.allSelection = false
    },
    // 查询
    loadTableData() {
      if (parseFloat(this.queryParams.rentableStartArea) >
          parseFloat(this.queryParams.rentableStopArea)) {
        return
      }
      const params = Object.assign(this.pagination, this.queryParams)
      // console.log(params)
      if (params.storageLocation != null && params.storageLocation.length > 0) {
        params.storageLocation = params.storageLocation.join('#')
      }
      findPageSupply(params)
        .then(data => {
          console.log(1484,data)
          this.data = data.result.rows.map(res => {
            res.hidden = true
            res.selection = false
            return res
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          this.pagination.total = this.data.length
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 删除
    del(id) {
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id) {
          supplyRemove({ id: id })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: '删除成功!'
              })
              this.loadData()
            })
            .cacth(error => {
              console.error(error)
            })
        }
      })
    },
    // 发布或编辑货源
    edit(supply) {
      const supplyData = JSON.parse(JSON.stringify(supply))
      if (supplyData) {
        if (supplyData.storageType) {
          supplyData.storageType = supplyData.storageType.split(',')
        } else {
          supplyData.storageType = []
        }

        if (supplyData.warehouseEquipment) {
          supplyData.warehouseEquipment = supplyData.warehouseEquipment.split(
            ','
          )
        } else {
          supplyData.warehouseEquipment = []
        }

        if (supplyData.storageLocation) {
          supplyData.storageLocation = supplyData.storageLocation.split('#')
        } else {
          supplyData.storageLocation = []
        }
      }
      this.storageSupply = supplyData
      this.invitationManager.visible = true
    },
    storageSupplyEdit(rulesForm) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            // console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const supply = JSON.parse(JSON.stringify(this.storageSupply))

          if (isValidArray(this.storageSupply.storageLocation)) {
            supply.storageLocation = this.storageSupply.storageLocation.join(
              '#'
            )
          } else {
            supply.storageLocation = ''
          }

          if (this.storageSupply.storageType) {
            supply.storageType = this.storageSupply.storageType.toString()
          } else {
            supply.storageType = ''
          }

          if (this.storageSupply.warehouseEquipment) {
            supply.warehouseEquipment = this.storageSupply.warehouseEquipment.toString()
          } else {
            supply.warehouseEquipment = ''
          }

          if (this.storageSupply.storageUrl) {
            supply.storageUrl = this.storageSupply.storageUrl.toString()
          } else {
            supply.storageUrl = ''
          }

          supply.createBy = null
          supply.updateBy = null
          supply.inviteUser = null
          supply.orderUser = null
          supplyEdit(supply)
            .then(result => {
              // 成功提示
              this.$message({
                offset: 100,
                showClose: true,
                message: '恭喜你，数据修改成功',
                type: 'success'
              })
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              this.post_flag = false
              this.invitationManager.visible = false
              this.loadData()
            })
        } else {
          // 失败返回数据
          return false
        }
      })
    },
    // 单条发布
    publishGetSupply(status, res) {
      // const ids = this.data.filter(item => item.selection).map(item => item.id)
      if (res != null && res.id != null) {
        this.$confirm(
          `是否确定${status == '2' ? '发布' : '下架'}本条仓库供给信息`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          if (status == '2') {
            const result = validateData(res)
            if (result && !result.state) {
              this.$message({
                type: 'error',
                message: `数据不完整，请先填写完整再发布!`
              })
              return false
            }
          }

          issueBatch({ id: JSON.stringify([res.id]), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          duration: 1000,
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    },
    // 批量发布
    publishsupply(status) {
      const items = this.data.filter(item => item.selection)
      if (items.length > 0) {
        this.$confirm(
          `是否确定${status == '2' ? '发布' : '下架'}选中的仓库供给信息`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          let ids = null
          if (status == '2') {
            ids = items
              .filter((item, index) => {
                const result = validateData(item)
                if (result && !result.state) {
                  this.$message({
                    type: 'error',
                    message: `所选第${parseInt(index) +
                      1}条数据不完整，请先填写完整再发布!`
                  })
                  return false
                }
                return true
              })
              .map(i => i.id)
          } else {
            ids = items.map(i => i.id)
          }
          if (ids.length == 0) return false
          issueBatch({ id: JSON.stringify(ids), publishStatus: status })
            .then(data => {
              this.$message({
                offset: 100,
                type: 'success',
                message: status == '2' ? '发布成功!' : '下架成功!'
              })
              this.loadData()
            })
            .catch(error => {
              console.error(error)
            })
        })
      } else {
        this.$message({
          offset: 100,
          type: 'warning',
          message: status == '2' ? '请选择要发布的数据!' : '请选择要下架的数据!'
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";
/deep/a {
  text-decoration: none;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
$main-color: #be2316;

/deep/.el-select {
  width: 100%;
}

/deep/.el-input-group__append,
.el-input-group__prepend {
  background-color: #ffffff;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #dcdfe6;
  border-left: 0;
  border-radius: 0px;
  padding: 0 10px;
  width: 1px;
  white-space: nowrap;
}

.content-container {
  .supply-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;
        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .supply-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }
        .supply-condition {
          display: flex;
          flex-wrap: wrap;
          /deep/.el-form-item .el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            width: 217px;
            .supply-area {
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #fff;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color 0.2s
                cubic-bezier(0.645, 0.045, 0.355, 1);
              transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
              width: 100%;
              /deep/.el-form-item__content {
                width: auto;
              }
              &:focus {
                border-color: #409eff;
                outline: 0;
              }
              &:hover {
                border-color: #c0c4cc;
              }
              .el-form-item {
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;
                /deep/.el-input .el-input__inner {
                  border: 0px solid #dcdfe6;
                  height: 36px;
                  line-height: 36px;
                  text-align: center;
                }
              }
            }
          }
          .el-form-item {
            display: flex;
            -webkit-box-pack: end;
            -ms-flex-pack: end;
            justify-content: flex-end;
            padding-right: 22px;
            width: 50%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-right: 0 !important;
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;

  }

  .supply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 5%;
          }
          &:nth-child(2) {
            flex-basis: 15.8%;
          }
          &:nth-child(3) {
            flex-basis: 15.8%;
          }
          &:nth-child(4) {
            flex-basis: 15.8%;
          }
          &:nth-child(5) {
            flex-basis: 15.8%;
          }
          &:nth-child(6) {
            flex-basis: 15.8%;
          }
          &:nth-child(7) {
            flex-basis: 15.8%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

      //       @keyframes slider-in {
      //   from {
      //     transform: translateX(100%);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(0);
      //     opacity: 1;
      //   }
      // }
      //  @keyframes slider-out {
      //   from {
      //     transform: translateX(0);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(-100%);
      //     opacity: 1;
      //   }
      // }
      // &.slider-in {
      //   visibility:visible !important;
      //   animation: slider-in 1s ease-in;
      // }
      // &.slider-out {
      //   visibility:visible !important;
      //   animation: slider-out 1s ease-out;
      // }
      // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 5%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 15%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(7) {
              flex-basis: 15.8%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button {
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .tankSupply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 12%;
          }
          &:nth-child(2) {
            flex-basis: 12%;
          }
          &:nth-child(3) {
            flex-basis: 12%;
          }
          &:nth-child(4) {
            flex-basis: 12%;
          }
          &:nth-child(5) {
            flex-basis: 12%;
          }
          &:nth-child(6) {
            flex-basis: 12%;
          }
          &:nth-child(7) {
            flex-basis: 12%;
          }
          &:nth-child(8) {
            flex-basis: 16%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

      //       @keyframes slider-in {
      //   from {
      //     transform: translateX(100%);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(0);
      //     opacity: 1;
      //   }
      // }
      //  @keyframes slider-out {
      //   from {
      //     transform: translateX(0);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(-100%);
      //     opacity: 1;
      //   }
      // }
      // &.slider-in {
      //   visibility:visible !important;
      //   animation: slider-in 1s ease-in;
      // }
      // &.slider-out {
      //   visibility:visible !important;
      //   animation: slider-out 1s ease-out;
      // }
      // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(2) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(7) {
              flex-basis: 11.2%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(8) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button {
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .orderSupply-data {
    .supply-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 16.8%;
          }
          &:nth-child(2) {
            flex-basis: 16.8%;
          }
          &:nth-child(3) {
            flex-basis: 16.8%;
          }
          &:nth-child(4) {
            flex-basis: 16.8%;
          }
          &:nth-child(5) {
            flex-basis: 16.8%;
          }
          &:nth-child(6) {
            flex-basis: 16%;
          }
        }
      }
    }

    .supply-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

      //       @keyframes slider-in {
      //   from {
      //     transform: translateX(100%);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(0);
      //     opacity: 1;
      //   }
      // }
      //  @keyframes slider-out {
      //   from {
      //     transform: translateX(0);
      //     opacity: 0.1;
      //   }
      //   to {
      //     transform:translateX(-100%);
      //     opacity: 1;
      //   }
      // }
      // &.slider-in {
      //   visibility:visible !important;
      //   animation: slider-in 1s ease-in;
      // }
      // &.slider-out {
      //   visibility:visible !important;
      //   animation: slider-out 1s ease-out;
      // }
      // visibility: hidden;

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          min-height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            margin: auto auto;
            position: relative;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(2) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(3) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(4) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(5) {
              flex-basis: 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 5px 0.4%;
            }
            &:nth-child(6) {
              flex-basis: 16%;
            }
            &:last-child {
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(4) {
                color: black !important;
              }
              /deep/.el-button {
                padding: 5px 0px;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 1s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .supply-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  // .invitation-data {
  //   .invitation-data-header {
  //     color: $main-color;
  //     font-weight: bold;
  //     background-color: #ffffff;
  //     height: 45px;
  //     margin-bottom: 1rem;
  //     ul {
  //       display: flex;
  //       flex-wrap: nowrap;
  //       height: 100%;
  //       width: calc(100% - 16px);
  //       padding: 8px 8px;
  //       box-sizing: content-box;
  //       li {
  //         overflow: hidden;
  //         white-space: nowrap;
  //         text-overflow: ellipsis;
  //         font-size: 15px;
  //         min-width: 50px;
  //         height: 100%;
  //         line-height: 29px;
  //         text-align: center;
  //         &:nth-child(1) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(2) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(3) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(4) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(5) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(6) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(7) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(8) {
  //           flex-basis: 10%;
  //         }
  //         &:nth-child(9) {
  //           flex-basis: 15%;
  //         }
  //         &:nth-child(10) {
  //           flex-basis: 15%;
  //         }
  //       }
  //     }
  //   }
  //   .invitation-data-body {
  //     position: relative;
  //     .data-item {
  //       margin: 8px 0px;
  //       box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  //       border: 1px solid #ebeef5;
  //       position: relative;
  //       ul {
  //         display: flex;
  //         flex-wrap: nowrap;
  //         height: 56px;
  //         width: calc(100% - 16px);
  //         padding: 8px 8px;
  //         position: relative;
  //         background-color: white;
  //         li {
  //           overflow: hidden;
  //           white-space: nowrap;
  //           text-overflow: ellipsis;
  //           font-size: 15px;
  //           min-width: 50px;
  //           height: 100%;
  //           line-height: 64px;
  //           text-align: center;
  //           &:nth-child(1) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(2) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(3) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(4) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(5) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(6) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(7) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(8) {
  //             flex-basis: 10%;
  //           }
  //           &:nth-child(9) {
  //             flex-basis: 15%;
  //           }
  //           &:nth-child(10) {
  //             flex-basis: 15%;
  //           }
  //         }
  //       }
  //       /deep/ .supply-item-details {
  //         border: 1px solid #ebeef5;
  //         z-index: 0;
  //       }
  //     }
  //   }
  //   .invitation-data-pagination {
  //     width: calc(100% - 32px);
  //     margin-top: 24px;
  //     padding: 16px 0px;
  //     background-color: white;
  //     width: 100%;
  //   }
  // }

  .bid-data {
    .bid-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 15%;
          }
          &:nth-child(3) {
            flex-basis: 8%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 7%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
          &:nth-child(11) {
            flex-basis: 10%;
          }
        }
      }
    }
    .bid-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 15%;
            }
            &:nth-child(3) {
              flex-basis: 8%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 7%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
            &:nth-child(11) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .bid-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-data {
    .recommend-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 10%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 10%;
          }
          &:nth-child(7) {
            flex-basis: 10%;
          }
          &:nth-child(8) {
            flex-basis: 10%;
          }
          &:nth-child(9) {
            flex-basis: 10%;
          }
          &:nth-child(10) {
            flex-basis: 10%;
          }
        }
      }
    }
    .recommend-data-body {
      position: relative;
      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;
        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;
          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            line-height: 64px;
            text-align: center;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 10%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 10%;
            }
            &:nth-child(7) {
              flex-basis: 10%;
            }
            &:nth-child(8) {
              flex-basis: 10%;
            }
            &:nth-child(9) {
              flex-basis: 10%;
            }
            &:nth-child(10) {
              flex-basis: 10%;
            }
          }
        }
        /deep/ .supply-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .recommend-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
}
</style>
